import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../components/UserContext';
import socket from '../socket';
import { nanoid } from 'nanoid';
import Header from '../components/Header';
import CreateRoomModal from '../components/CreateRoomModal';
import RoomCreatedModal from '../components/RoomCreatedModal'
import JoinRoomModal from '../components/JoinRoomModal';
import Wocaicai_Emoji_02 from '../assets/images/Wocaicai_Emoji_02.png';
import Wocaicai_Emoji_03 from '../assets/images/Wocaicai_Emoji_03.png'; 
import Wocaicai_Emoji_04 from '../assets/images/Wocaicai_Emoji_04.png';
import { Plus, LogIn, ArrowBigLeft, ArrowBigRight } from "lucide-react";

const Lobby = () => {
    const { user } = useContext(UserContext);
    const [users, setUsers] = useState([]);
    const [rightPanelOpen, setRightPanelOpen] = useState(false);
    const sidePanelRef = useRef(null);
    const navigate = useNavigate();

        const playerName = user?.username || 'Guest_' + Math.floor(Math.random() * 1000);
        const playerId = user?.user_id || crypto.randomUUID();
        const [role, setRole] = useState("guesser");
        const player = { id: playerId, name: playerName, role: role, score: 0, status: 'waiting' };

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showJoinModal, setShowJoinModal] = useState(false);
    const [joinError, setJoinError] = useState('');
    const [createdRoom, setCreatedRoom] = useState(null);
    
    const [error, setError] = useState('');
    const [availableRooms, setAvailableRooms] = useState({});
    const [initirRoomId, setinitirRoomId] = useState('');

    const handleCreateRoom = (roomData) => {
        const newRoomId = nanoid(6); 
        const createdRoomData = { ...roomData, roomId: newRoomId };
        socket.emit('create-room', createdRoomData);
        setCreatedRoom(createdRoomData);
      };

    const handleJoinRoom = ({ roomId, roomKey }) => {
        const cleanedRoomId = roomId.replace(/\s/g, ''); 
        socket.emit('join-room', {
            initirRoomId: initirRoomId,
            roomId: cleanedRoomId,
            playerData: player,
            roomKey: roomKey
        });
    };

    useEffect(() => {
        /*socket.on('available-rooms', (data) => {
            console.log('📦 Room created from server:', data);
            setAvailableRooms(data);
          });*/

        if (user) {
            socket.emit('user-info', user);
        }

          socket.on('update-user-list', (userList) => {
            setUsers(userList);
          });

          socket.on('join-response', ({ success, fullRoomData: createdRoomData, message, initirRoomId }) => {
            if (success) {
                const query = createdRoomData.roomType === 'private' ? `?key=${createdRoomData.roomKey}` : '';
                navigate(`/room/${createdRoomData.roomId}${query}`);
            } else {
                setJoinError(message || 'Failed to join the room.');
                if (initirRoomId) {
                    setinitirRoomId(initirRoomId);
                    // Joining from Available Rooms (private)
                    setShowJoinModal(true);
                    //setShowRoomKeyModal(true);
                } else {
                    // Manual join
                    //setShowRoomKeyModal(false);
                    setShowJoinModal(true);
                }
            }
        });

        return () => {
            socket.off('room-created');
            socket.off('available-rooms');
            socket.off('join-response');
            socket.off('update-user-list');
        };
    }, [playerId]);

return (
  <div className="relative h-screen overflow-hidden">
    <Header />

    {/* Floating Side Panel */}
      <div className="fixed top-[73px] right-0 h-[calc(100%-73px)] z-50 flex" ref={sidePanelRef}>
        {/* Toggle Button */}
        <button
          onClick={() => setRightPanelOpen(!rightPanelOpen)}
          className="bg-[#FFCC21] text-white font-bold p-2 rounded-l-2xl shadow-md 
            hover:bg-yellow-400 transition-all self-start 
            opacity-70 hover:opacity-100"
        >
          {rightPanelOpen ? <ArrowBigRight /> : <ArrowBigLeft />}
        </button>

        {/* Sliding Panel */}
            <div
                className={`transition-all duration-300 ease-in-out h-full overflow-x-hidden shadow-lg ${rightPanelOpen ? 'w-80' : 'w-0 p-0'
                    }`}
            >

          {rightPanelOpen && (
            <div className="bg-white rounded-bl-[2.5rem] p-6 w-full lg:w-80 shadow-md h-full overflow-y-auto overflow-x-hidden">
              <h3 className="font-bold text-lg mb-2">Players Online</h3>
              <ul className="space-y-2">
                {users.length > 0 ? (
                  users.map((u, index) => {
                    const isCurrentUser = u.user_id === playerId;
                    return (
                      <li
                        key={index}
                        className={`rounded p-2 transition-colors ${
                          isCurrentUser
                            ? 'bg-[#2A71F5] text-white'
                            : 'bg-gray-100 text-gray-700'
                        }`}
                      >
                      <span className='notranslate truncate max-w-[6rem]' translate="no" title={u.username}>{u.username}</span>
                        {isCurrentUser && <span className="ml-2 text-xs font-semibold">(You)</span>}
                      </li>
                    );
                  })
                ) : (
                  <li className="text-gray-500 italic">No users yet</li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>


    <div className="min-h-screen flex flex-col p-4 md:p-8">
      
      {/* Floating Emojis */}
    <img
        src={Wocaicai_Emoji_02}
        alt="Emoji"
        className="absolute animate-float-up-down w-[25vw] h-[25vw] right-[5vw] top-[80vh] md:w-[136.82px] md:h-[136.82px] md:right-[115px] md:top-[75vh] z-[-1]"
        style={{
          filter: 'drop-shadow(0px 12px 8px rgba(0, 0, 0, 0.6))',
          transform: 'rotate(14.88deg)',
        }}
    />

    <img
        src={Wocaicai_Emoji_03}
        alt="Emoji"
        className="absolute animate-float-up-down w-[30vw] h-[30vw] right-[10vw] top-[12vh] md:w-[222.75px] md:h-[222.75px] md:right-[210px] md:top-[104.06px] z-[-1]"
        style={{
          filter: 'drop-shadow(0px 12px 8px rgba(0, 0, 0, 0.6))',
          transform: 'rotate(14.88deg)',
        }}
    />

    <img
        src={Wocaicai_Emoji_04}
        alt="Emoji"
        className="absolute animate-float-up-down  w-[30vw] h-[30vw] left-[5vw] top-[78vh] max-w-[326.18px] max-h-[326.18px] md:w-[326.18px] md:h-[326.18px] md:left-[8px] md:top-[40vh] z-[-1] "
        style={{
            filter: 'drop-shadow(0px 12px 8px rgba(0, 0, 0, 0.6))',
            transform: 'rotate(-9.56deg)',
        }}
    />


      {/* Centered Content Area */}
      <div className="flex-1 flex flex-col items-center justify-center mx-auto w-[90%] max-w-2xl">
        <h1 className="tittle-app text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 text-center">
         Let the Game Comes Alive!
        </h1>
        <p className="description-app text-base sm:text-lg text-white mb-6 text-center">
          Step into the heart of Wocaicai, where the real action begins. Create your own game room or jump into one with friends — the guessing, the laughter, the challenge — it all starts here. Get ready to connect, compete, and charade your way to victory!
        </p>

        {/* Create and Join Buttons */}
        <div className="flex flex-col md:flex-row gap-4 w-full max-w-md mx-auto pt-6">
          <button
            className="font-bold flex-1 relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
            bg-[#FF1111] rounded-2xl shadow-[0_6px_0_0_#C30F0F]
            transition-all duration-150 ease-in-out
            hover:scale-[1.03]
            hover:brightness-110
            active:translate-y-[4px] active:shadow-none"
            onClick={() => setShowCreateModal(true)}
          >
            <div className="flex items-center justify-center gap-2">
              <Plus size={20} className="inline-block" />
              <span >Create Game</span>
            </div>
          </button>

          <button
            className="font-bold flex-1 relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
            bg-[#FFCC21] rounded-2xl shadow-[0_6px_0_0_#FFA600]
            transition-all duration-150 ease-in-out
            hover:scale-[1.03]
            hover:brightness-110
            active:translate-y-[4px] active:shadow-none"
            onClick={() => setShowJoinModal(true)}
          >
            <div className="flex items-center justify-center gap-2">
              <LogIn size={20} className="inline-block text-[#FF1111]" />
              <span className="text-[#FF1111]">Join Room</span>
            </div>
          </button>
                </div>

                    {showCreateModal && (
                        <CreateRoomModal
                            onClose={() => setShowCreateModal(false)}
                            onCreate={handleCreateRoom}
                        />
                    )}
                    {createdRoom && (
                        <RoomCreatedModal
                            roomId={createdRoom.roomId}
                            createdBy={createdRoom.createdBy}
                            createdRoomData={createdRoom}
                        />
                    )}
                    {showJoinModal && (
                        <JoinRoomModal
                            onClose={() => setShowJoinModal(false)}
                            onJoin={handleJoinRoom}
                            error={joinError}
                            initialRoomId={initirRoomId} 
                            requireRoomId={false}
                        />
                    )}
                </div>
            </div>
        </div>
    );
    
};

export default Lobby;